(function(){
  'use strict';

  // Variant resolution
  document.querySelectorAll('[data-section-id]').forEach(function(section){
    var jsonEl = document.querySelector('[data-product-json="' + section.dataset.sectionId + '"]');
    if(!jsonEl) return;

    var productData;
    try { productData = JSON.parse(jsonEl.textContent); } catch(e){ return; }

    var chips = section.querySelectorAll('[data-var]');
    var idInput = section.querySelector('[data-product-id-input]');
    var hiddenSelect = section.querySelector('[data-variant-select]');
    var priceTargets   = section.querySelectorAll('[data-bind="price"], [data-bind-current-price]');
    var compareTargets = section.querySelectorAll('[data-bind-compare-price]');
    var addBtn = section.querySelector('.btn-cart');

    function currentSelection(){
      var selections = [], seen = {};
      section.querySelectorAll('[data-var]').forEach(function(btn){
        if(btn.classList.contains('is-active') && !seen[btn.dataset.var]){
          seen[btn.dataset.var] = true;
          selections.push(btn.dataset.value);
        }
      });
      return selections;
    }

    function findVariant(selections){
      if(!productData || !productData.variants) return null;
      return productData.variants.find(function(v){
        return v.options.every(function(opt, i){
          return (opt || '').toString().toLowerCase() === (selections[i] || '').toString().toLowerCase();
        });
      });
    }

    function formatMoney(cents){
      return '$' + (cents/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function syncVariant(){
      var v = findVariant(currentSelection());
      if(!v) return;
      if(idInput) idInput.value = v.id;
      if(hiddenSelect) hiddenSelect.value = v.id;
      priceTargets.forEach(function(el){ el.textContent = formatMoney(v.price); });
      compareTargets.forEach(function(el){
        if (v.compare_at_price && v.compare_at_price > v.price) {
          el.textContent = formatMoney(v.compare_at_price);
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      });
      if(addBtn){
        addBtn.disabled = !v.available;
        if(v.available) addBtn.removeAttribute('disabled');
        else addBtn.setAttribute('disabled', 'disabled');
      }

      // Stock indicator — swap label + class based on variant availability
      section.querySelectorAll('[data-bind-stock]').forEach(function(el){
        if (v.available) {
          el.textContent = el.dataset.inStockLabel || 'In stock';
          el.classList.remove('info__stock--out');
        } else {
          el.textContent = el.dataset.outOfStockLabel || 'No stock — Custom Order';
          el.classList.add('info__stock--out');
        }
      });

      // SKU / barcode / weight — surface variant-level metadata in the
      // "More details" disclosure on the main product section.
      section.querySelectorAll('[data-bind-sku]').forEach(function(el){
        el.textContent = v.sku || '—';
      });
      section.querySelectorAll('[data-bind-barcode]').forEach(function(el){
        el.textContent = v.barcode || '—';
      });
      section.querySelectorAll('[data-bind-weight]').forEach(function(el){
        if (v.weight && v.weight > 0) {
          var unit = v.weight_unit || 'kg';
          el.textContent = v.weight + ' ' + unit;
        } else {
          el.textContent = '—';
        }
      });

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      } catch(e){}
    }

    // Defensive cleanup: clear any stale lock classes from a previous version
    chips.forEach(function(b){ b.classList.remove('is-disabled', 'is-soldout'); b.disabled = false; });

    function eq(a, b){ return (a || '').toString().toLowerCase() === (b || '').toString().toLowerCase(); }

    // Find the variant that best matches the new selection after a chip click.
    // 1. Try exact match.
    // 2. Otherwise: among variants where the just-clicked option matches,
    //    pick the one whose OTHER options best match the current selection.
    //    Prefer available variants on a tie.
    function snapToVariant(selections, changedIdx){
      if (!productData || !productData.variants) return null;

      // Exact match first
      var exact = productData.variants.find(function(v){
        return v.options.every(function(opt, i){ return eq(opt, selections[i]); });
      });
      if (exact) return exact;

      // Candidates where the just-clicked option matches
      var candidates = productData.variants.filter(function(v){
        return eq(v.options[changedIdx], selections[changedIdx]);
      });
      if (!candidates.length) return null;

      var best = null, bestScore = -1;
      candidates.forEach(function(v){
        var score = 0;
        v.options.forEach(function(opt, i){
          if (i === changedIdx) return;
          if (eq(opt, selections[i])) score++;
        });
        if (v.available) score += 0.5; // tiebreaker: prefer available variants
        if (score > bestScore) { best = v; bestScore = score; }
      });
      return best;
    }

    // Update all chips + value labels to mirror a given variant's options
    function applyVariant(v){
      if (!v || !productData || !productData.options) return;
      v.options.forEach(function(optVal, i){
        var optName = productData.options[i];
        if (!optName) return;
        var optHandle = optName.toString().toLowerCase().replace(/\s+/g, '-');
        section.querySelectorAll('[data-var="' + optHandle + '"]').forEach(function(b){
          b.classList.toggle('is-active', eq(b.dataset.value, optVal));
        });
        section.querySelectorAll('[data-bind="' + optHandle + '"]').forEach(function(el){
          el.textContent = optVal;
        });
      });
    }

    chips.forEach(function(btn){
      btn.addEventListener('click', function(){
        var group = btn.dataset.var;
        var groupIdx = parseInt(btn.dataset.optionIndex, 10);

        // Activate this chip first
        section.querySelectorAll('[data-var="' + group + '"]').forEach(function(b){
          b.classList.toggle('is-active', b === btn);
        });
        section.querySelectorAll('[data-bind="' + group + '"]').forEach(function(el){
          el.textContent = btn.dataset.value;
        });

        // Snap to closest valid variant, auto-updating other options if needed
        var sel = currentSelection();
        var v = snapToVariant(sel, groupIdx);
        if (v) applyVariant(v);

        syncVariant();
      });
    });
  });

  // Gallery thumbs
  document.querySelectorAll('.gallery__thumb').forEach(function(btn){
    btn.addEventListener('click', function(){
      var section = btn.closest('section');
      section.querySelectorAll('.gallery__thumb').forEach(function(b){
        b.classList.toggle('is-active', b === btn);
      });
      section.querySelectorAll('.gallery__img').forEach(function(i){
        i.classList.toggle('is-active', i.dataset.mediaId === btn.dataset.mediaId);
      });
    });
  });

  // Quantity stepper
  document.querySelectorAll('[data-qty]').forEach(function(b){
    b.addEventListener('click', function(){
      var input = b.parentElement.querySelector('input[type="number"]');
      var v = parseInt(input.value || '1', 10);
      v += b.dataset.qty === '+' ? 1 : -1;
      if(v < 1) v = 1;
      input.value = v;
    });
  });

  // Accordion
  document.querySelectorAll('.acc__head').forEach(function(head){
    head.addEventListener('click', function(){
      var open = head.parentElement.classList.toggle('is-open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // Lightbox
  document.querySelectorAll('[data-action="zoom"]').forEach(function(zoom){
    zoom.addEventListener('click', function(){
      var section = zoom.closest('section');
      var lb = document.getElementById('lightbox-' + section.dataset.sectionId);
      var lbImg = document.getElementById('lightbox-img-' + section.dataset.sectionId);
      var active = section.querySelector('.gallery__img.is-active');
      if(lbImg && active) lbImg.innerHTML = active.innerHTML;
      if(lb){ lb.classList.add('is-on'); document.body.style.overflow = 'hidden'; }
    });
  });

  document.querySelectorAll('.lightbox').forEach(function(lb){
    function close(){ lb.classList.remove('is-on'); document.body.style.overflow = ''; }
    lb.addEventListener('click', function(e){ if(e.target === lb) close(); });
    var btn = lb.querySelector('[data-close]');
    if(btn) btn.addEventListener('click', close);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
  });

  // Lazy recommendations
  document.querySelectorAll('[data-product-recommendations]').forEach(function(el){
    var url = el.dataset.url;
    if(!url) return;
    var io = new IntersectionObserver(function(entries, obs){
      entries.forEach(function(entry){
        if(!entry.isIntersecting) return;
        obs.unobserve(el);
        fetch(url).then(function(r){ return r.text(); }).then(function(html){
          var tmp = document.createElement('div');
          tmp.innerHTML = html.trim();
          var fresh = tmp.querySelector('[data-product-recommendations]');
          if(fresh) el.innerHTML = fresh.innerHTML;
        }).catch(function(){});
      });
    }, { rootMargin: '200px' });
    io.observe(el);
  });
})();
